// @file    lucide-icons.provider.ts
// @created 2026-07-01 by Claude
// @desc    Registers exactly the Lucide icons referenced by the IHUB host-match
//          redesign (the unique targets of FA_LUCIDE in fa-lucide.map.ts).
//          Selective pick keeps the bundle small. Add the matching entry here
//          AND in fa-lucide.map.ts when a new icon is introduced.

import { importProvidersFrom, Provider, EnvironmentProviders } from '@angular/core';
import {
  LucideAngularModule,
  Armchair, ArrowLeft, ArrowRight, Award, Ban, Banknote, Bell, BellOff, BriefcaseMedical, Calendar, CalendarCheck, CalendarDays, CalendarPlus, CalendarX, Car, ChartColumn, ChartPie, Check, CheckCheck, ChevronDown, ChevronLeft, ChevronRight, CircleAlert, CircleCheck, CircleQuestionMark, CircleX, ClipboardPlus, Clock, CloudDownload, Coins, CreditCard, DollarSign, Download, ExternalLink, Facebook, FileCheck, FilePen, FileText, FingerprintPattern, Gift, GraduationCap, HandCoins, HandHeart, Hash, Headset, Heart, HeartCrack, HeartPulse, History, Hourglass, House, HousePlus, IdCard, Inbox, Info, Landmark, Languages, ListChecks, LoaderCircle, LogOut, Mail, Map, MapPin, MessageCircle, Package, Phone, PhoneCall, PiggyBank, Printer, QrCode, Receipt, RotateCw, Send, Shield, ShieldCheck, ShieldHalf, ShieldUser, Sparkles, SquarePen, Sun, Tag, Ticket, TrendingUp, TriangleAlert, Umbrella, User, UserCheck, Users, Wallet, X, Zap,
} from 'lucide-angular';

/** Add to ApplicationConfig.providers to make these icons resolvable by name. */
export function provideLucideIcons(): (Provider | EnvironmentProviders)[] {
  return [
    importProvidersFrom(LucideAngularModule.pick({
    Armchair,
    ArrowLeft,
    ArrowRight,
    Award,
    Ban,
    Banknote,
    Bell,
    BellOff,
    BriefcaseMedical,
    Calendar,
    CalendarCheck,
    CalendarDays,
    CalendarPlus,
    CalendarX,
    Car,
    ChartColumn,
    ChartPie,
    Check,
    CheckCheck,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    CircleAlert,
    CircleCheck,
    CircleQuestionMark,
    CircleX,
    ClipboardPlus,
    Clock,
    CloudDownload,
    Coins,
    CreditCard,
    DollarSign,
    Download,
    ExternalLink,
    Facebook,
    FileCheck,
    FilePen,
    FileText,
    FingerprintPattern,
    Gift,
    GraduationCap,
    HandCoins,
    HandHeart,
    Hash,
    Headset,
    Heart,
    HeartCrack,
    HeartPulse,
    History,
    Hourglass,
    House,
    HousePlus,
    IdCard,
    Inbox,
    Info,
    Landmark,
    Languages,
    ListChecks,
    LoaderCircle,
    LogOut,
    Mail,
    Map,
    MapPin,
    MessageCircle,
    Package,
    Phone,
    PhoneCall,
    PiggyBank,
    Printer,
    QrCode,
    Receipt,
    RotateCw,
    Send,
    Shield,
    ShieldCheck,
    ShieldHalf,
    ShieldUser,
    Sparkles,
    SquarePen,
    Sun,
    Tag,
    Ticket,
    TrendingUp,
    TriangleAlert,
    Umbrella,
    User,
    UserCheck,
    Users,
    Wallet,
    X,
    Zap,
    })),
  ];
}
